import { SipNumberResponse } from "../../model/sipNumberResponse";
import { transformDate } from "../../utils/date-helpers";
import { getPhoneNumberE164 } from "../../utils/general-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipNumberResponse;

type FetchResponseType = {
  data?: DtoType;
  error?: string;
};

export type TransformedDataType = DtoType & {
  phoneNumberX: string;
  addedToPoolX: string;
  releaseDateX: string;
  lastUsedBySystemX: string;
};

export type ResponseGuiType = {
  data?: TransformedDataType;
  error?: string;
};

export async function getSipNumber(
  sipNumberId: string
): Promise<ResponseGuiType> {
  try {
    const url = apiUrls.getSipNumber.replace("{{id}}", sipNumberId);
    const response: FetchResponseType = await fetchGetJSON(url);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const item = response.data;
      const responseX = {
        ...item,
        phoneNumberX: getPhoneNumberE164(item.phoneNumber),
        addedToPoolX: transformDate(item.addedToPool),
        releaseDateX: transformDate(item.releaseDate),
        lastUsedBySystemX: transformDate(item.lastUsedBySystem),
      };
      return { data: responseX /*.slice(0,1)*/ };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getSipNumber:%o", err);
    return { error: (err as Error).message };
  }
}
